import { ReactNode } from 'react';
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Tooltip,
    Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useReactHookForm } from '../../hooks/useReactHookForm';
import { useSaveData } from '../../hooks/useSaveData';
import { ReactHookForm } from '../../components/hook-form/react-hook-form.component';
import { LoadingIndicator } from '../../components/loading-indicator.component';
import { operationManagementApiKeyStore } from '../../api/masters/operation-management-api-key-store';
import { useAuthorize } from '../../hooks/use-authorize';
import { UserPermissionName } from '../../models/user-permission-name';

interface SaveDataDialogProps {
    children: ReactNode;
    title: string;
    data: any;
    updateManagement: () => void;
    onClose: () => void;
    onSaveCompleted?: (data: any) => void;
    yupSchema?: any;
    formatSubmitdata?: (data: any) => any;
    size: any;
    isLoading?: boolean;
}

export const SaveInspectionDialog = ({
    children,
    title,
    data,
    yupSchema,
    updateManagement,
    onClose,
    onSaveCompleted,
    formatSubmitdata,
    size,
    isLoading: isLoadingFromApi,
}: SaveDataDialogProps) => {
    const form = useReactHookForm({
        defaultValues: {
            ...data,
        },
        yupSchema,
    });

    const { isLoading, isError, error, mutateAsync } = useSaveData(operationManagementApiKeyStore.updateOperationManagement());

    const closeDialogHandler = () => {
        form.reset();
        onClose();
    };

    const submitHanlder = async (data: any) => {
        const formattedData = formatSubmitdata ? formatSubmitdata(data) : data;
        if (formattedData) {
            const result = await mutateAsync({ data: formattedData });
            onSaveCompleted?.(result.data);
            updateManagement();
            closeDialogHandler();
        }
    };

    const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

    return (
        <Dialog open={true} fullWidth={true} maxWidth={size}>
            <DialogTitle id="form-dialog-title">{title}</DialogTitle>
            <IconButton
                aria-label="close"
                onClick={closeDialogHandler}
                sx={{
                    position: 'absolute',
                    right: 10,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <Tooltip title={<Typography variant="body1">Close</Typography>}>
                    <CloseIcon />
                </Tooltip>
            </IconButton>
            <ReactHookForm formName="SEVE_INSPECTION_FORM" onSubmit={submitHanlder} formContextProps={form}>
                <DialogContent dividers className="popupDilog">
                    <LoadingIndicator isLoading={isLoading} isSpinner />
                    {/* <ApiErrorComponent isError={isError} errorRespnse={error} /> */}
                    {children}
                </DialogContent>
                <div style={{ padding: '5px', paddingLeft: '16px', paddingRight: '16px' }}>
                    <DialogActions className="spaceBetween">
                        <Button variant="outlined" style={{ width: '130px' }} onClick={closeDialogHandler}>
                            Cancel
                        </Button>
                        <Button
                            type="button"
                            disabled={isLoading || isLoadingFromApi || isReadOnlyPermission}
                            variant="contained"
                            style={{ width: '130px' }}
                            onClick={() => form.handleSubmit(submitHanlder)()}
                        >
                            Save
                        </Button>
                    </DialogActions>
                </div>
            </ReactHookForm>
        </Dialog>
    );
};
